import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardBody } from 'reactstrap';

import ProceduresTable from './table';
import { formatTableRespone, toSelectOptionsV2 } from '../../../utils/formatters';

class ProceduresList extends Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    page: PropTypes.number.isRequired,
    sizePerPage: PropTypes.number.isRequired,
    totalSize: PropTypes.number.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
    procedures: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    districts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    towns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    areas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    fetchProcedures: PropTypes.func.isRequired,
    fetchDistricts: PropTypes.func.isRequired,
    fetchTowns: PropTypes.func.isRequired,
    fetchAreas: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { fetchProcedures, page, districts, fetchDistricts, towns, areas, fetchTowns, fetchAreas } = this.props;
    fetchProcedures({ page });

    if (!districts.length) fetchDistricts({ page: 1, limit: 1000 });
    if (!towns.length) fetchTowns({ page: 1, limit: 1000 });
    if (!areas.length) fetchAreas({ page: 1, limit: 1000 });
  }

  handleTableChange = (type, data) => {
    const { fetchProcedures } = this.props;
    fetchProcedures(formatTableRespone(data));
  };

  render() {
    const { procedures, page, sizePerPage, totalSize, isFetching, districts, towns, areas } = this.props;
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <b>Административные процедуры</b>
          </CardHeader>
          <CardBody>
            <ProceduresTable
              data={procedures}
              districts={toSelectOptionsV2(districts, 'district', 'id')}
              towns={toSelectOptionsV2(towns, null, 'id')}
              areas={toSelectOptionsV2(areas, null, 'id')}
              page={page}
              isLoading={isFetching}
              sizePerPage={sizePerPage}
              totalSize={totalSize}
              onTableChange={this.handleTableChange}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default ProceduresList;
